export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.BASE_URL || '/'}sw.js`).then((registration) => {
      const update = () => {
        registration.update().catch(() => {})
      }
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') update()
      })
    }).catch((error) => {
      console.warn('Service Worker注册失败:', error)
    })
  })
}
